import { AuditModel } from "../pages/shared/models/AuditModel";
import { HistoryResponseModel } from "../pages/shared/models/api/history-response.model";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

function getSchema(category: string) {
  switch (category) {
    case "Order":
      return "orders";
    case "Balance":
      return "balances";
  }
}

async function getHistoryByCategoryId(
  category: string,
  categoryId: number,
  filter: object,
): Promise<AuditModel[]> {
  try {
    const schema = getSchema(category);
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .post(
        `${API_URL}/activities/${schema}/${categoryId}`,
        filter,
        authorizationHeader,
      )
      .then((result) => result.data);
  } catch (error) {
    console.error(error);
    return [] as AuditModel[];
  }
}

async function getFilteredHistory(
  filter: object = {},
  limit?: number,
  page?: number,
): Promise<HistoryResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(`${API_URL}/activities`, filter, { params, ...authorizationHeader })
      .then((result) => result.data as HistoryResponseModel);
  } catch (error) {
    console.error(error);
    return {
      currentPage: 0,
      audit: [],
      pageSize: 10,
      totalItems: 0,
    } as HistoryResponseModel;
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getHistoryByCategoryId,
  getFilteredHistory,
};
